import React, { useEffect, useState } from 'react'
import "./stylestabs.scss";
import { email_icon, info_cicrle, phone_icon } from "../../../components/ExportImgFigma";
import { calculateAge } from '../../../services/mixin';
import { Tooltip } from 'antd';
import { SHOW_KEYNAME } from '../../../env';
import MegaTable from '../../../components/MagaTableV2';
import { SettingOutlined } from '@ant-design/icons';

const InfomationLeft = ({ stData = {} as any }) => {
  const [fieldsToShow, setFieldsToShow] = useState<any>([]);
  const [custype, setCustype] = React.useState('');
  useEffect(() => {
    const tempCustype = stData.cus_type_name === 'Đơn vị, tổ chức' || stData.cus_type_name === 'đơn vị, tổ chức' ? 'cty' : 'cn';
    setCustype(tempCustype);
  }, [stData.cus_type_name]);


  const tableColumnsCty = (sourceColumnWarehouse: any) => {
    const temp = [] as any
    sourceColumnWarehouse.customer_cty_detail?.list.map((col: any) => {
      temp.push({
        headerName: col.headerName,
        field: col.field,
      })
    })
    return temp
  }
  const [megaTableData, setMegaTableData] = useState<any>({
    name: 'TbCacheInfomationLeftCty',
    col: [
      ...tableColumnsCty(stData.sourceColumnWarehouse),
    ],
    listData: [],
    tableColDefs: [],
    height: '400px',
  });
  useEffect(() => {
    const temp = [] as any
    megaTableData.tableColDefs.map((col: any) => {
      if (col.hide === true) return;
      temp.push({
        label: col.headerName,
        keyname: col.field,
        value: stData[col.field]
      })
    })
    if (custype === 'cty') {
      setFieldsToShow([...temp]);
    }
  }, [megaTableData.tableColDefs, custype]);

  // for cn
  const tableColumnsCn = (sourceColumnWarehouse: any) => {
    const temp = [] as any
    sourceColumnWarehouse.customer_detail?.list.map((col: any) => {
      temp.push({
        headerName: col.headerName,
        field: col.field,
      })
    })
    return temp
  }
  const [megaTableDataCn, setMegaTableDataCn] = useState<any>({
    name: 'TbCacheInfomationLeftCn',
    col: [
      ...tableColumnsCn(stData.sourceColumnWarehouse),
    ],
    listData: [],
    tableColDefs: [],
  });
  useEffect(() => {
    const temp = [] as any
    megaTableDataCn.tableColDefs.map((col: any) => {
      if (col.hide === true) return;
      temp.push({
        label: col.headerName,
        keyname: col.field,
        value: stData[col.field]
      })
    })
    if (custype === 'cn') {
      setFieldsToShow([...temp]);
    }
  }, [megaTableDataCn.tableColDefs, custype]);
  return (
    <div className="dark-user-profile">
      <div className='d-none'>
        <MegaTable
          stData={{ ...megaTableData, listData: [] }}
          stChange={(data) => {
            setMegaTableData((prev: any) => ({ ...prev, ...data }));
          }}
        />
        <MegaTable
          stData={{ ...megaTableDataCn, listData: [] }}
          stChange={(data) => {
            setMegaTableDataCn((prev: any) => ({ ...prev, ...data }));
          }}
        />
      </div>

      {/* Profile Header */}
      <div className="profile-header v2">
        {stData.cus_gender_name === 'Nữ' ? (
          <div className="avatar">
            <svg xmlns="http://www.w3.org/2000/svg" shapeRendering="geometricPrecision" textRendering="geometricPrecision" imageRendering="optimizeQuality" fillRule="evenodd" clipRule="evenodd" viewBox="0 0 512 512"><path fill="#D0D0D0" d="M0 0h512v512H0z" /><path fill="#B1B1B1" d="M174.139 280.588c-11.32-3.697-19.915-9.191-25.926-16.341 17.362-6.542 25.352-27.052 26.478-57.757.835-22.826-3.905-41.685 3.882-64.21 15.414-44.591 72.372-59.828 104.114-33.739 24.888-2.654 49.962 10.181 55.377 48.562 4.041 28.659-4.537 58.357 4.509 84.756 3.891 11.359 10.644 20.047 21.213 25.126-6.775 6.479-16.593 10.776-28.368 13.647-9.112 2.225-25.572 3.932-44.737 4.953v13.44l18.649 24.916-53.361 42.435-53.299-42.057 14.238-23.909v-14.445c-18.584-.88-34.318-2.619-42.769-5.377zm160.831 64.768c-8.26-16.581-18.734-30.641-30.926-43.854 22.977 8.89 50.179 17.669 67.564 28.573 11.06 6.933 16.776 12.157 21.25 20.55 11.016 20.66 9.396 43.614 15.285 65.592H103.856c5.885-21.978 4.266-44.932 15.286-65.592 4.474-8.393 10.186-13.617 21.25-20.55 17.38-10.904 44.582-19.683 67.564-28.573-12.192 13.213-22.666 27.273-30.93 43.854l23.926-.586 53.716 42.901 56.375-42.901 23.927.586z" /></svg>
          </div>
        ) : (
          <div className="avatar">
            <svg xmlns="http://www.w3.org/2000/svg" shapeRendering="geometricPrecision" textRendering="geometricPrecision" imageRendering="optimizeQuality" fillRule="evenodd" clipRule="evenodd" viewBox="0 0 512 512"><path fill="#D0D0D0" d="M0 0h512v512H0z" /><path fill="#B1B1B1" d="M86.655 416.22c7.264-94.069 37.323-70.129 106.837-113.622 21.47 44.795 108.726 48.051 126.619 0 59.99 38.35 105.701 16.656 105.23 113.622H86.655zm123.222-117.155c-.926-1.202 2.423-9.452 3.216-10.787-9.081-8.081-16.258-16.235-17.788-33.013l-.973.02c-2.249-.03-4.418-.547-6.449-1.704-3.252-1.85-5.539-5.025-7.084-8.606-3.27-7.514-14.042-32.452 2.37-30.481-9.177-17.137 11.592-46.413-24.228-57.241 29.389-37.222 91.398-94.614 136.841-37.044 49.739 4.82 65.255 63.932 31.762 96.307 1.962.071 3.811.523 5.448 1.399 6.226 3.335 6.43 10.574 4.794 16.646-1.619 5.073-3.676 8.505-5.614 13.45-2.359 6.676-5.806 7.919-12.467 7.2-.338 16.507-7.967 24.609-18.233 34.307l2.809 9.517c-13.767 29.202-70.958 30.377-94.404.03z" /></svg>
          </div>
        )}

        <div className="profile-info v2">
          <h2 className="name font-light font-light" {...(SHOW_KEYNAME === true && { 'col-id': 'cus_name' })}>
            {stData.cus_name[0]}
            {stData.cus_name && stData.cus_name.length > 1 &&
              <Tooltip placement="rightBottom" arrow={false} title={stData.cus_name.map((tel: any, index: number) => (
                <div key={index}>{tel}</div>
              ))}>
                <div className="action-icons action-icons-bage ml-auto px-2 fs-14">
                  <div className="font-light color-bage">{stData.cus_name.length}</div>
                  <img src={info_cicrle} alt="Avatar" />
                </div>
              </Tooltip>
            }
          </h2>
          <p className="customer-id font-light" {...(SHOW_KEYNAME === true && { 'col-id': 'cus_crm' })}>CID: {stData.cus_crm}</p>
        </div>
      </div>
      <div className="profile-gender-t">
        {custype !== 'cty' && (
          <div className="flex items-center mb-3">
            <div className="flex items-center gap-2">
              <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M13.1282 0.304762C13.1282 0.215873 13.159 0.142857 13.2205 0.0857143C13.2821 0.0285714 13.3607 0 13.4564 0H16.4103C16.588 0 16.7419 0.0603175 16.8718 0.180952C17.0017 0.301587 17.0667 0.444444 17.0667 0.609524V3.35238C17.0667 3.44127 17.0359 3.51429 16.9744 3.57143C16.9128 3.62857 16.8342 3.65714 16.7385 3.65714H16.0821C15.9863 3.65714 15.9077 3.62857 15.8462 3.57143C15.7846 3.51429 15.7538 3.44127 15.7538 3.35238V2.07619L13.1487 4.50476C14.0103 5.50794 14.441 6.64762 14.441 7.92381C14.441 9.32698 13.9368 10.5476 12.9282 11.5857C11.9197 12.6238 10.6735 13.219 9.18974 13.3714V14.6286H10.1744C10.2701 14.6286 10.3487 14.6571 10.4103 14.7143C10.4718 14.7714 10.5026 14.8444 10.5026 14.9333V15.5429C10.5026 15.6317 10.4718 15.7048 10.4103 15.7619C10.3487 15.819 10.2701 15.8476 10.1744 15.8476H9.18974V16.7619C9.18974 16.8508 9.15897 16.9238 9.09744 16.981C9.0359 17.0381 8.95727 17.0667 8.86154 17.0667H8.20513C8.1094 17.0667 8.03077 17.0381 7.96923 16.981C7.90769 16.9238 7.87692 16.8508 7.87692 16.7619V15.8476H6.89231C6.79658 15.8476 6.71795 15.819 6.65641 15.7619C6.59487 15.7048 6.5641 15.6317 6.5641 15.5429V14.9333C6.5641 14.8444 6.59487 14.7714 6.65641 14.7143C6.71795 14.6571 6.79658 14.6286 6.89231 14.6286H7.87692V13.3714C6.39316 13.219 5.14701 12.6238 4.13846 11.5857C3.12991 10.5476 2.62564 9.32698 2.62564 7.92381C2.62564 6.64762 3.05641 5.50794 3.91795 4.50476L3.38462 4L2.34872 5.05714C2.28718 5.12064 2.21197 5.15397 2.12308 5.15714C2.03419 5.16032 1.95556 5.13651 1.88718 5.08571L1.39487 4.66667C1.3265 4.61587 1.2906 4.54762 1.28718 4.4619C1.28376 4.37619 1.31282 4.30159 1.37436 4.2381L2.45128 3.14286L1.31282 2.07619V3.35238C1.31282 3.44127 1.28205 3.51429 1.22051 3.57143C1.15897 3.62857 1.08034 3.65714 0.984615 3.65714H0.328205C0.232479 3.65714 0.153846 3.62857 0.0923077 3.57143C0.0307692 3.51429 0 3.44127 0 3.35238V0.609524C0 0.444444 0.0649573 0.301587 0.194872 0.180952C0.324786 0.0603175 0.478632 0 0.65641 0H3.61026C3.70598 0 3.78462 0.0285714 3.84615 0.0857143C3.90769 0.142857 3.93846 0.215873 3.93846 0.304762V0.914286C3.93846 1.00317 3.90769 1.07619 3.84615 1.13333C3.78462 1.19048 3.70598 1.21905 3.61026 1.21905H2.24615L3.33333 2.2381L4.21538 1.34286C4.27692 1.27937 4.35214 1.24603 4.44103 1.24286C4.52991 1.23968 4.60855 1.26349 4.67692 1.31429L5.16923 1.73333C5.23761 1.78413 5.2735 1.85238 5.27692 1.9381C5.28034 2.02381 5.25128 2.09841 5.18974 2.1619L4.26667 3.10476L4.85128 3.6381C5.93162 2.8381 7.15897 2.4381 8.53333 2.4381C9.90769 2.4381 11.135 2.8381 12.2154 3.6381L14.8308 1.21905H13.4564C13.3607 1.21905 13.2821 1.19048 13.2205 1.13333C13.159 1.07619 13.1282 1.00317 13.1282 0.914286V0.304762ZM8.53333 12.1905C9.79829 12.1905 10.8803 11.773 11.7795 10.9381C12.6786 10.1032 13.1282 9.09841 13.1282 7.92381C13.1282 6.74921 12.6786 5.74444 11.7795 4.90952C10.8803 4.0746 9.79829 3.65714 8.53333 3.65714C7.26838 3.65714 6.18632 4.0746 5.28718 4.90952C4.38803 5.74444 3.93846 6.74921 3.93846 7.92381C3.93846 9.09841 4.38803 10.1032 5.28718 10.9381C6.18632 11.773 7.26838 12.1905 8.53333 12.1905Z" fill="black" fill-opacity="0.85" /> </svg>
              <div className="text-left-information font-light" {...(SHOW_KEYNAME === true && { 'col-id': 'cus_gender_name' })}>{stData.cus_gender_name && stData.cus_gender_name !== '' ? stData.cus_gender_name : 'không xác định'}</div>
            </div>
          </div>
        )}

        <div className="flex items-center mb-3">
          <div className="flex items-center gap-2">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M15.36 1.44H12V0.16C12 0.072 11.928 0 11.84 0H10.72C10.632 0 10.56 0.072 10.56 0.16V1.44H5.44V0.16C5.44 0.072 5.368 0 5.28 0H4.16C4.072 0 4 0.072 4 0.16V1.44H0.64C0.286 1.44 0 1.726 0 2.08V15.36C0 15.714 0.286 16 0.64 16H15.36C15.714 16 16 15.714 16 15.36V2.08C16 1.726 15.714 1.44 15.36 1.44ZM14.56 14.56H1.44V6.96H14.56V14.56ZM1.44 5.6V2.88H4V3.84C4 3.928 4.072 4 4.16 4H5.28C5.368 4 5.44 3.928 5.44 3.84V2.88H10.56V3.84C10.56 3.928 10.632 4 10.72 4H11.84C11.928 4 12 3.928 12 3.84V2.88H14.56V5.6H1.44Z" fill="#344054" /> </svg>
            <div className="text-left-information font-light" {...(SHOW_KEYNAME === true && { 'col-id': 'cus_birth_day' })}>{stData.cus_birth_day && stData.cus_birth_day !== '' && stData.cus_birth_day !== 'Không xác định' ? `${calculateAge(stData.cus_birth_day)} tuổi` : '-- tuổi'}</div>
          </div>
        </div>
      </div>


      {custype !== 'cty' && (
        <div className="flex items-center mb-3">
          <div className="flex items-center gap-2">
            <svg width="11" height="15" viewBox="0 0 11 15" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M0.599609 9.26823C0.599609 9.88106 0.720316 10.4879 0.954838 11.0541C1.18936 11.6203 1.5331 12.1347 1.96644 12.5681C2.39978 13.0014 2.91423 13.3451 3.48042 13.5797C4.04661 13.8142 4.65344 13.9349 5.26628 13.9349C5.87911 13.9349 6.48595 13.8142 7.05213 13.5797C7.61832 13.3451 8.13277 13.0014 8.56611 12.5681C8.99945 12.1347 9.34319 11.6203 9.57771 11.0541C9.81224 10.4879 9.93294 9.88106 9.93294 9.26823C9.93294 8.65539 9.81224 8.04856 9.57771 7.48237C9.34319 6.91619 8.99945 6.40174 8.56611 5.9684C8.13277 5.53506 7.61832 5.19131 7.05213 4.95679C6.48595 4.72227 5.87911 4.60156 5.26628 4.60156C4.65344 4.60156 4.04661 4.72227 3.48042 4.95679C2.91423 5.19131 2.39978 5.53506 1.96644 5.9684C1.5331 6.40174 1.18936 6.91619 0.954838 7.48237C0.720316 8.04856 0.599609 8.65539 0.599609 9.26823Z" stroke="black" stroke-opacity="0.85" stroke-width="1.2" /> <path d="M5.26628 4.60156L2.59961 1.9349L3.93294 0.601562H5.26628M5.26628 4.60156L7.93294 1.9349L6.59961 0.601562H5.26628" stroke="black" stroke-opacity="0.85" stroke-width="1.2" /> </svg>
            <div className="text-left-information font-light" {...(SHOW_KEYNAME === true && { 'col-id': 'cus_marital_status' })}>{stData.cus_marital_status && stData.cus_marital_status !== '' && stData.cus_marital_status !== 'Không xác định' ? stData.cus_marital_status : 'Hôn nhân không xác định'}</div>
          </div>
        </div>
      )}

      {stData.cus_tel && stData.cus_tel.length > 0 &&
        <div className="flex items-center mb-3">
          <div className="flex items-center gap-2">
            <img src={phone_icon} alt="" />
            <div className="text-left-information font-light" {...(SHOW_KEYNAME === true && { 'col-id': 'cus_tel' })}>{stData.cus_tel[0]}</div>
          </div>

          {stData.cus_tel && stData.cus_tel.length > 1 &&
            <Tooltip placement="rightBottom" arrow={false} title={stData.cus_tel.map((tel: any, index: number) => (
              <div key={index}>{tel}</div>
            ))}>
              <div className="action-icons action-icons-bage ml-auto px-2 fs-14">
                <div className="font-light color-bage">{stData.cus_tel.length}</div>
                <img src={info_cicrle} alt="Avatar" />
              </div>
            </Tooltip>
          }
        </div>
      }
      {stData.cus_email &&
        <div className="flex items-center mb-3">
          <div className="flex items-center gap-2">
            <img src={email_icon} alt="" />
            <div className="text-left-information font-light" {...(SHOW_KEYNAME === true && { 'col-id': 'cus_email' })}>{stData.cus_email}</div>
          </div>
          {/* <div className="action-icons action-icons-bage ml-auto px-2 fs-14">
            <div className="font-light color-bage">{stData.cus_email ? 1 : 0}</div>
            <img src={info_cicrle} alt="Avatar" />
          </div> */}
        </div>
      }

      <div className="information-tab__content-left mt-2">
        <div className="d-flex justify-between w-full mb-1 items-center">
          <span className="font-medium">{custype === 'cty' ? 'Thông tin doanh nghiệp' : 'Thông tin cá nhân'}</span>
          <div className='settingCol'>
            {custype === 'cty' ?
              <div className='ctr-col-setting' onClick={() => setMegaTableData((prev: any) => ({ ...prev, showSetting: true }))}>
                <SettingOutlined />
              </div>
              :
              <div className='ctr-col-setting' onClick={() => setMegaTableDataCn((prev: any) => ({ ...prev, showSetting: true }))}>
                <SettingOutlined />
              </div>
            }
          </div>
        </div>

        <div className="information-table-show v2">
          {fieldsToShow.map((field: any) => (
            <div className={`event-none-form-item event-none-radio event-none-Flex item ${!field.value || (Array.isArray(field.value) && field.value.length === 0) ? 'd-none' : ''}`} key={field.label}>
              <span className="item-left white-space-nowrap">{field.label}:</span>
              <span className="item-right">
                <span className="d-flex align-center gap-1" {...(SHOW_KEYNAME === true && { 'col-id': field.keyname })}>
                  {Array.isArray(field.value) ? field.value[0] : field.value}
                </span>
              </span>
              {Array.isArray(field.value) && field.value.length > 1 &&
                <Tooltip placement="rightBottom" arrow={false} title={field.value.map((vx: any, index: number) => (
                  <div key={index}>{vx}</div>
                ))}>
                  <div className="action-icons action-icons-bage ml-auto px-2 fs-14 absolute-right-area">
                    <div className="font-light color-bage">{field.value.length}</div>
                    <img src={info_cicrle} alt="Avatar" />
                  </div>
                </Tooltip>

              }
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default InfomationLeft;
